import { Datagrid, List, SearchInput, TextField } from 'react-admin';
import { useBulkActionButtons } from '../deleteControls';
import { PurlListActions } from './purl';

// #84 - free-text search: partial match on agency name, PURL domain, and
// contact person/email.
const agencyFilters = [
    <SearchInput source="q" placeholder="Name, domain, or contact" alwaysOn />,
];

export const AgencyList = () => {
    const bulkActionButtons = useBulkActionButtons();
    return (
        <List perPage={25} filters={agencyFilters}>
            <Datagrid rowClick="edit" bulkActionButtons={bulkActionButtons}>
                <TextField source="name" />
                <TextField source="sourceId" label="Source Agency ID" />
                <TextField source="domain" label="PURL domain" />
                <PurlListActions label="" sortable={false} />
            </Datagrid>
        </List>
    );
};

export default AgencyList;
